import { useTheme } from 'styled-components';
import Column from './components/box/column';
import SizedBox from './components/box/sizedBox';
import Center from './components/center';
import { LXh5 } from './texts/lxText';

const NotFoundPage: React.FC = () => {
  const theme = useTheme();

  return (
    <Center>
      <Column justifyContent="center" alignItems="center">
        <LXh5>Sorry! Page Not Found!</LXh5>
        <SizedBox height={8}></SizedBox>
        <LXh5>This uri is not valid</LXh5>
        <SizedBox height={8}></SizedBox>
        <LXh5>If you think this is error. connect us</LXh5>
        <SizedBox height={8}></SizedBox>
        <LXh5>{`Email : ${theme.texts.slxEmail}`}</LXh5>
      </Column>
    </Center>
  );
};

export default NotFoundPage;
